
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan.delegationCharges', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/charges',
    views: {
      '': {
        template: require('./charges/list/index.html')
      },
      'principal@': {
        template: require('./charges/list/chargesList.html'),
        controller: 'ChargesListCtrl',
        controllerAs: 'chargesListVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Cargos por delegación',
      order: 1,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.roles',
          order: 2
        },
        {
          name: 'workplan.committeeParticipation',
          order: 3
        },
        {
          name: 'workplan.otherActivities',
          order: 4
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.academicManagement,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.academicManagement', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/charges',
    views: {
      '': {
        template: require('./charges/list/index.html')
      },
      'principal@': {
        template: require('./charges/list/chargesList.html'),
        controller: 'ChargesListCtrl',
        controllerAs: 'chargesListVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Gestión Académica',
      order: 1,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.roles',
          order: 2
        },
        {
          name: 'workplan.committeeParticipation',
          order: 3
        },
        {
          name: 'workplan.otherActivities',
          order: 4
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.academicManagement,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.roles', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/roles',
    views: {
      '': {
        template: require('./roles/list/index.html')
      },
      'principal@': {
        template: require('./roles/list/rolesList.html'),
        controller: 'RolesListCtrl',
        controllerAs: 'rolesListVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Roles',
      order: 2,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.delegationCharges',
          order: 1
        },
        {
          name: 'workplan.committeeParticipation',
          order: 3
        },
        {
          name: 'workplan.otherActivities',
          order: 4
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.academicManagement,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.committeeParticipation', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/committeeParticipation',
    views: {
      '': {
        template: require('./committeeParticipation/list/index.html')
      },
      'principal@': {
        template: require('./committeeParticipation/list/participationsList.html'),
        controller: 'ParticipationListCtrl',
        controllerAs: 'participationListVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Participación en comités',
      order: 3,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.delegationCharges',
          order: 1
        },
        {
          name: 'workplan.roles',
          order: 2
        },
        {
          name: 'workplan.otherActivities',
          order: 4
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.academicManagement,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.createParticipation', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/createParticipation/:workplanTeacherActivityId',
    template: require('./committeeParticipation/createParticipation/createParticipation.html'),
    controller: 'CreateParticipationCtrl',
    controllerAs: 'participationVm',
    data: {
      displayName: 'Participación en comités',
      order: 3,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.delegationCharges',
          order: 1
        },
        {
          name: 'workplan.roles',
          order: 2
        },
        {
          name: 'workplan.otherActivities',
          order: 4
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.createRole', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/createRole/workplan/:workplanTeacherActivityId/activity/:activityTypeId',
    template: require('./roles/createRole/createRole.html'),
    controller: 'CreateRoleCtrl',
    controllerAs: 'createRoleVm',
    data: {
      displayName: 'Roles',
      order: 2,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.delegationCharges',
          order: 1
        },
        {
          name: 'workplan.committeeParticipation',
          order: 3
        },
        {
          name: 'workplan.otherActivities',
          order: 4
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.otherActivities', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/otherActivitiesList',
    views: {
      '': {
        template: require('./otherActivities/listActivities/index.html')
      },
      'principal@': {
        template: require('./otherActivities/listActivities/otherActivitiesList.html'),
        controller: 'OtherActivitiesListCtrl',
        controllerAs: 'activitiesVm'
      },
      'indicators@': {
        template: require('../indicators/indicators.html'),
        controller: 'IndicatorsCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Otras actividades',
      order: 4,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.delegationCharges',
          order: 1
        },
        {
          name: 'workplan.roles',
          order: 2
        },
        {
          name: 'workplan.committeeParticipation',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      indicatorType: GlobalConfig.indicatorsType.academicManagement,
      stage: GlobalConfig.workplanStages.planning
    }
  })
  .state('workplan.createOtherActivity', {
    moduleId: GlobalConfig.modules.academicManagement,
    abstract: false,
    url: '/academicManagement/createOtherActivity/:activityId',
    template: require('./otherActivities/createOtherActivity/createOtherActivity.html'),
    controller: 'CreateOtherActivityCtrl',
    controllerAs: 'createActivityVm',
    data: {
      displayName: 'Otras actividades',
      order: 4,
      title: 'Gestión Académica',
      siblings: [
        {
          name: 'fullscreen.workPlanGeneralInformation',
          order: 0
        },
        {
          name: 'workplan.delegationCharges',
          order: 1
        },
        {
          name: 'workplan.roles',
          order: 2
        },
        {
          name: 'workplan.committeeParticipation',
          order: 3
        },
        {
          name: 'workplan.history',
          order: 5
        }
      ]
    },
    params: {
      stage: GlobalConfig.workplanStages.planning
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/academic.route.js